import {isInViewport} from '../helpers/ElementHelper';

export class MediaPostsComponent {
  container = null;
  swiperContainer = null;
  swiper = null;

  constructor() {
    this.container = document.querySelector('.media-posts');
    if (!this.container) {
      return;
    }

    this.swiperContainer = this.container.querySelector('.swiper-container');
    if (!this.swiperContainer) {
      return;
    }

    this.initialize();
    this.addEventListeners();
  }

  async initialize() {
    await this.initializeSwiper();

    this.togglePlay();
  }

  addEventListeners() {
    window.addEventListener('scroll', (e) => this.windowScrollHandler(e));
    window.addEventListener('resize', (e) => this.windowResizeHandler(e));
  }

  windowScrollHandler(e) {
    this.togglePlay();
  }

  windowResizeHandler(e) {
    this.togglePlay();
  }

  togglePlay() {
    if (!this.swiper) {
      return;
    }

    isInViewport(this.swiperContainer) ? this.swiper.autoplay.start() : this.swiper.autoplay.stop();
  }

  async initializeSwiper() {
    let attempts = 0;

    const interval = setInterval(() => {
      if (attempts > 9) {
        clearInterval(interval);
      }

      attempts++;

      if (this.swiperContainer.classList.contains('swiper-container-initialized')) {
        this.swiper = this.swiperContainer.swiper;
        clearInterval(interval);
      }
    }, 100);
  }
}